import Config from '../Config';
import { RestService } from './RestService';

export const RoleService = {
    getRoleList: async function(){
        return RestService.get(`${Config.get_roles}`, {})
        .then(response => response.json());
    }
};